import script from "./NewsPressReleases.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsPressReleases.vue?vue&type=script&lang=ts&setup=true"

import "./NewsPressReleases.vue?vue&type=style&index=0&id=e642e3da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e642e3da"]])

export default __exports__